<template>
  <div class="dropdown dropdown--right">
    <button class="account__notice js-dropdown-toggle" @click="handleClick">
      <i class="las la-bell"></i>
      <span class="account__notice__num" v-if="visibleNotifications.length"></span>
    </button>
    <div class="dropdown__inner dropdown__inner--activity">
      <div class="dropdown__list">
        <template v-if="visibleNotifications.length">
          <div class="dropdown__activity" :class="{unread: !item.read_at && !readNotifications.includes(item.id), disabled: btnLoading}"
               v-for="(item, index) in visibleNotifications" :key="index" @click="readNotification(item)">
            <div class="dropdown__user">
              <img :src="getAvatarLink(item.data.user_id ? item.data.user_id : null)">
            </div>
            <div class="dropdown__content">
              <p v-html="notificationContent(item)"></p>
              <small class="dropdown__content__date">{{ notificationDate(item) }}</small>
            </div>
          </div>
          <div class="text-center">
            <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
            <button v-if="notifications.hasMore" class="account__notice__more" @click="loadNotification">もっと見る</button>
            <!-- <button v-if="notifications.hasMore" @click="loadNotification">もっと見る</button> -->
          </div>
        </template>
        <div class="dropdown__activity" v-else>
          <div class="dropdown__user">
            <img :src="fetchImage()">
          </div>
          <div class="dropdown__content">
            <p style="color: #888;">ここに通知が表示されます</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import closeDropDownMixin from "~/mixins/closeDropDownMixin";
  import { mapState, mapGetters } from "vuex";
  import {fetchImageMixin} from '~/mixins/global';
  import notificationMixin from "~/mixins/notificationMixin";

  export default {
    name: 'f-header-notification',
    mixins: [closeDropDownMixin, fetchImageMixin, notificationMixin],
    computed: {
      ...mapState({
        btnLoading: rootState => rootState.btnLoading
      }),
      ...mapGetters({
        notifications: 'frontend/user/getBellNotifications',
      }),
      visibleNotifications() {
        return this.notifications.data.filter(function (item) {
          if((
              item.data.type != 'proposal_self_commented'
              && item.data.type != 'proposal_comment_mention'
          ) || !item.data?.is_proposal) {
            return item;
          }
        });
      }
    },
    data: () => ({
      isLoading: false,
    }),
    methods: {
      handleClick(e) {
        this.hiddenDropdown(e);
        e.target.parentNode.classList.toggle("open");
        if (e.target.parentNode.classList.contains('open')) {
          this.fetchNotification();
        }
      },
      async loadNotification() {
        this.isLoading = true;
        const lastNotificationTime = this.notifications.data.length
                ? this.notifications.data[this.notifications.data.length - 1].created_at
                : '';
        await this.$store.dispatch('frontend/user/getBellNotifications', lastNotificationTime);
        this.isLoading = false;
      },
      async fetchNotification() {
        this.isLoading = true;
        const firstNotificationTime = this.notifications.data.length
            ? this.notifications.data[0].created_at
            : '';
        await this.$store.dispatch('frontend/user/fetchBellNotifications', firstNotificationTime);
        this.isLoading = false;
      },
      notificationContent(notification) {
        switch (notification.data.type) {
          case 'step_assigned':
            return this.stepAssigned(notification.data);
          case 'task_assigned':
            return this.taskAssigned(notification.data);
          case 'todo_alarm_at':
            return this.todoAlarmAt(notification.data);
          case 'task_in_step_completed':
            return this.taskInStepCompleted(notification.data);
          case 'proposal_self_commented':
            return this.proposalSelfComment(notification.data);
          case 'proposal_commented':
            return this.proposalCommented(notification.data);
          case 'weekly_task_remind':
            return this.weeklyTaskRemind(notification.data);
          case 'daily_task_remind':
            return this.dailyTaskRemind(notification.data);
          case 'todo_notifi_start_day':
            return this.todoNotifiStartDay(notification.data);
          case 'daily_step_remind':
            return this.dailyStepRemind(notification.data);
          case 'approve_request_received':
            return this.approveRequestReceived(notification.data);
          case 'approve_request_accept':
            return this.approveRequestAccept(notification.data);
          case 'approve_request_reject':
            return this.approveRequestReject(notification.data);
          case 'document_completed':
            return this.documentCompleted(notification.data);
          case 'file_uploaded':
            return this.fileUploaded(notification.data);
          case 'document_commented':
            return this.documentCommented(notification.data);
          case 'ls_proposal_created':
            return this.lsProposalCreated(notification.data);
          case 'user_joined':
            return this.userJoined(notification.data);
          case 'proposal_comment_mention':
            return this.proposalCommentMention(notification.data);
          case 'document_comment_mention':
            return this.documentCommentMention(notification.data);
        }
        return '';
      },
      getAvatarLink(userId) {
        if (userId && this.notifications.avatarList) {
          let obj = this.notifications.avatarList.find((item) => {
            return item.id === userId;
          })

          if (obj !== undefined && obj.avatar !== "") {
            return obj.avatar;
          }
        }
        return '/img/avatars/user.png';
      },
    }
  }
</script>

<style scoped lang="scss">
.disabled {
  pointer-events: none;
}
</style>